import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Stack, Box, Button, Card, IconButton, Input, InputBase, Avatar, Dialog, DialogTitle, DialogContent, TextField, MenuItem, DialogActions, Typography, TableContainer, TableHead, TableBody, Paper, Table, TableRow, TableCell, Popover, DialogContentText, CircularProgress, FormControl, InputLabel, Select, OutlinedInput, Chip, ToggleButtonGroup, ToggleButton, Tabs, Tab, Grid, FormLabel } from '@mui/material';
import Iconify from 'src/components/iconify';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { getData, patchData, postData, putData, uploadFile } from 'src/webService/webService';
import { toast } from 'react-toastify';
import PaginationComponent from 'src/components/pagination';
import wordIcon from '../../components/logo/icons-word.png'
import pdfIcon from '../../components/logo/icons-pdf.png'
import { file_URL } from '../../utils/url'

function ContentCreation() {

    const [open, setOpen] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);
    const UserId = sessionStorage.getItem('userId');
    const [view, setView] = useState([]);
    const [selectedId, setSelectedId] = useState(null);
    const [details, setDetails] = useState(false);
    const [scroll, setScroll] = useState('paper');
    const descriptionElementRef = useRef(null);
    const [selectedLead, setSelectedLead] = useState("");
    const [allUpdates, setAllUpdates] = useState([]);
    const [fileUpload, setFileUpload] = useState(null);
    const [selectedWorkUpdateId, setSelectedWorkUpdateId] = useState(null);
    const [convertForm, setConvertForm] = useState(false);
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [ccData, setCCData] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState({});
    const [dailyData, setDailyData] = useState([]);
    const [events, setEvents] = useState([]);
    const [openReminderDialog, setOpenReminderDialog] = useState(false);
    const [selectedReminder, setSelectedReminder] = useState(null);
    const [reminderId, setReminderId] = useState(null);
    const [contentId, setContentId] = useState(null);

    const [selectedLeadId, setSelectedLeadId] = useState(null);
    const [assignedLeads, setAssignedLeads] = useState([]);
    const [openImage, setOpenImage] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');

    const sessionToken = sessionStorage.getItem("Token");
    const role = sessionStorage.getItem("role");
    const roleType = sessionStorage.getItem("roleType");
    const serviceTeamType = sessionStorage.getItem("serviceTeamType");
    const [activeTab, setActiveTab] = useState(0);

    const [totalCount, setTotalCount] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [cameraId, setCameraId] = useState("");
    const [formData, setFormData] = useState({
        projectName: "",
        keywords: "",
        seoFocus: "",
        status: "",
        fileUpload: "",
        comments: "",
        completionStatus: "",
        totalTasks: "",
        completedTasks: ""
    });

    console.log("Reminder Id", reminderId)

    const [convertData, setConvertData] = useState({
        ...(role === "Admin"
            ? {
                serviceName: ["Camera Man"],
                projectName: "",
                shootType: "",
                location: "",
                assignedTo: [],
            }
            : {
                serviceName: ["Content Creation"],
                employeeWork: [],
                employeeWork: {},
                noOfPosters: [],
                deadline: [],
                status: [],
                assignedTo: [],
            }
        ),
        serviceStatus: "",
        deadline: "",
        comments: "",
        totalShots: "",
        paymentStatus: "",
        assignedShots: "",
    });

    const convertLeads = async () => {
        debugger;
        try {
            const sessionToken = sessionStorage.getItem("Token");
            if (!sessionToken) {
                toast.error("Authentication Error! Please login again.");
                return;
            }

            if (role === "Admin") {
                const payLoad = {
                    projectName: convertData.projectName,
                    assignedShots: convertData.assignedShots,
                    shootType: convertData.shootType,
                    location: convertData.location,
                    assignedTo: convertData.assignedTo,
                    deadline: convertData.deadline,
                    comments: convertData.comments,
                    totalShots: convertData.totalShots,
                    serviceName: "Camera Man",
                    PaymentStatus: convertData.paymentStatus,
                    leadId: selectedLeadId,
                    userId: UserId
                };

                const response = await patchData(`camera/camera/${cameraId}`, payLoad, sessionToken);
                if (response.status === 200) {
                    toast.success("Camera Service Assigned successfully!");
                } else {
                    throw new Error(response.message || "Failed to assign Camera Service");
                }

            } else if (roleType === "Team Leader") {
                const params = {
                    serviceName: ["Content Creation"],
                    assignedTo: convertData.assignedTo,
                    employeeWork: convertData.employeeWork,
                    serviceStatus: "In Progress",
                    noOfPosters: convertData.noOfPosters,
                    deadline: convertData.deadline,
                    status: convertData.status
                };
                const putResponse = await putData(`leads/lead/${selectedLeadId}/status`, params, sessionToken);
                console.log(putResponse, "Put Response")
                if (putResponse.status === 200) {
                    toast.success("Lead Assigned successfully!");
                }
            }

            setConvertForm(false);
            await fetchAssignedLeads();

        } catch (error) {
            console.error("Error converting lead:", error);
            toast.error(`Operation failed: ${error.message}`);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setConvertData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    console.log(view, 'viewwwww')

    const handleMultiSelectChange = (event) => {
        const {
            target: { value },
        } = event;
        setConvertData((prev) => ({
            ...prev,
            assignedTo: typeof value === 'string' ? value.split(',') : value,
        }));
    };

    const handleFormOpen = async (leadId) => {
        handleCloseMenu()
        await getAllUsers();
        setSelectedLeadId(leadId);
        setConvertForm(true);
        setOpen(false);
    }

    const getAllUsers = async () => {
        try {
            const params = { page: 1, limit: 1000 }
            const response = await getData("users/users", params);
            console.log("Response:", response);

            let filteredUsers = [];

            if (role === "Admin") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Camera Man") && user.roleType === "Team Leader"
                );
            } else if (roleType === "Team Leader") {
                filteredUsers = response.data.results.filter(user =>
                    user.serviceTeamType && user.serviceTeamType.includes("Content Creation")
                );
            }

            const formattedOptions = filteredUsers.map(user => ({
                id: user._id,
                name: user.name
            }));

            setEmployeeOptions(formattedOptions);
        } catch (error) {
            console.error("Error fetching users:", error);
            toast.error("Failed to load users");
        }
    };

    const handleFormClose = () => {
        setConvertForm(false)
    }

    const handleFormChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleFileChange = (event, leadId) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFiles(prev => ({ ...prev, [leadId]: file }));
            handleFileUpload(file, leadId);
        }
    };

    const handleFileUpload = async (fileupload, leadId) => {
        console.log("Fileupload:", fileupload);
        console.log("Is File:", fileupload instanceof File);

        const formDataToSend = new FormData();
        formDataToSend.append("file", fileupload);

        try {
            const response = await uploadFile(`files/upload/${selectedLeadId}`, formDataToSend);
            if (response?.status === 200) {
                toast.success("File uploaded successfully!");
                setFileUpload(response?.data);
                setFormData(prevState => ({
                    ...prevState,
                    fileupload: response?.data,
                }));
            } else {
                toast.error("File upload failed!");
            }
        } catch (error) {
            console.error("File upload error:", error);
            toast.error("Error uploading file.");
        }
    };

    const handleOpenMenu = (event, task, id, workUpdateId) => {
        debugger
        let lead;
        { role === "Admin" && getLeadById(id) }
        // getDailyUpdates(id)
        if (task && typeof task === 'object') {
            lead = task;
            setSelectedLead(lead);
        }
        else {
            lead = assignedLeads.find((data) => data._id === id);
            setSelectedLead(lead);
        }

        if (event?.currentTarget) {
            setOpenMenu(event.currentTarget);
            setSelectedLeadId(id);
            setSelectedWorkUpdateId(workUpdateId);
            setView(lead || task); // Set view to either the lead object or the task data
        }
    };

    const handleCloseMenu = () => {
        setOpenMenu(false);
    };

    const handleOpenDialog = async () => {
        await getAllUpdatesAdmin();
        setDetails(true);
        handleCloseMenu();
    };

    const handleCloseDialog = () => {
        setDetails(false);
    };

    const handleOpen = async () => {
        setOpen(true);
        handleCloseMenu();
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleReminderClick = (eventClickInfo) => {
        debugger
        const event = eventClickInfo.event;
        if (event.extendedProps.type === 'reminder') {
            const leadId = event.id.split('-reminder-')[0];
            const lead = assignedLeads.find(l => l._id === leadId);
            setContentId(lead?.contentCreationHistory?._id)
            setReminderId(event.extendedProps.reminderId)
            setSelectedReminder({
                leadId,
                leadName: lead?.name || 'Unknown',
                projectName: lead?.contentCreationHistory?.projectName || 'N/A',
                totalTasks: lead?.contentCreationHistory?.totalTasks || 0,
                completedTasks: lead?.contentCreationHistory?.completedTasks || 0,
                completionPercentage: lead?.contentCreationHistory?.completionPercentage || 0,
                deadline: lead?.contentCreationHistory?.deadline ? new Date(lead.contentCreationHistory.deadline).toLocaleDateString() : 'N/A',
                createdAt: lead?.contentCreationHistory?.createdAt ? new Date(lead.contentCreationHistory.createdAt).toLocaleDateString() : 'N/A',
                updatedAt: lead?.contentCreationHistory?.updatedAt ? new Date(lead.contentCreationHistory.updatedAt).toLocaleDateString() : 'N/A',
                status: lead?.contentCreationHistory?.status || 'N/A',
                reminderMessage: event.title,
                reminderDate: event.start ? new Date(event.start).toLocaleDateString() : 'N/A',
            });
            setOpenReminderDialog(true);
        }
    };

    const handleCloseReminderDialog = () => {
        setOpenReminderDialog(false);
        setSelectedReminder(null);
    };

    const handleMarkReminderCompleted = async () => {
        debugger
        try {
            const lead = assignedLeads.find(l => l._id === selectedReminder.leadId);
            if (!lead) {
                toast.error("Lead not found!");
                return;
            }

            const response = await postData(`reminder/contentcreation/${contentId}/${reminderId}`, {}, sessionToken);
            if (response?.status === 200) {
                toast.success("Reminder marked as completed!");
                setOpenReminderDialog(false);
                setSelectedReminder(null);
                await fetchAssignedLeads();
            } else {
                throw new Error(response?.message || "Failed to mark reminder as completed.");
            }
        } catch (error) {
            console.error("Error marking reminder as completed:", error);
            toast.error(`Operation failed: ${error.message}`);
        }
    };

    useEffect(() => {
        if (details) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [details]);

    const fetchAssignedLeads = async () => {
        debugger
        try {
            let response;
            let contentCreationLeads = [];

            if (role === "Admin" || roleType === "Team Leader") {
                const payload = { serviceName: "Content Creation", page: currentPage, limit: limit }
                response = await getData("leads/services", payload, sessionToken);
                contentCreationLeads = response.data.results[0].paginatedResults;
                const totalRecords = response?.data.results[0]?.totalCount;
                setTotalPages(response?.data.results[0]?.totalPages);
                setTotalCount(totalRecords);

            } else if (roleType === "Employee") {
                const params = {
                    page: currentPage,
                    limit: limit
                };

                const endpoint = `leads/leads/${UserId}`;

                response = await getData(endpoint, params, sessionToken);

                if (roleType === "Employee" && response?.data) {
                    debugger
                    const leadsData = Array.isArray(response.data)
                        ? response.data[0]?.paginatedResults
                        : response.data[0]?.paginatedResults || [];

                    contentCreationLeads = leadsData;
                    const totalRecords = response.data[0].totalCount.totalItems;
                    setTotalPages(response.data[0].totalPages === null ? 0 : response.data[0].totalPages);
                    setTotalCount(totalRecords);

                }
            }

            setAssignedLeads(contentCreationLeads);
            console.log("Content Creation", contentCreationLeads)

            const latestDeadlines = {};
            contentCreationLeads.forEach(lead => {
                const leadId = lead._id;
                const deadline = lead.contentCreationHistory?.deadline;
                if (deadline && (!latestDeadlines[leadId] ||
                    new Date(deadline) > new Date(latestDeadlines[leadId].deadline))) {
                    latestDeadlines[leadId] = lead;
                }
            });

            const latestDeadlinesArray = Object.values(latestDeadlines);

            const deadlineEvents = latestDeadlinesArray.map(lead => ({
                id: lead._id + '-deadline',
                // title: `Deadline: ${lead.contentCreationHistory?.contentType || 'Content'}`,
                start: lead.contentCreationHistory?.deadline,
                allDay: true,
                extendedProps: {
                    type: 'deadline',
                    leadName: lead.name,
                    contentType: lead.contentCreationHistory?.contentType,
                    progress: lead.contentCreationHistory?.completionPercentage
                        ? `${Math.round(lead.contentCreationHistory.completionPercentage)}%`
                        : '0%'
                },
                backgroundColor: '#FF8A80',
                borderColor: '#FF8A80',
                textColor: '#000'
            }));

            const reminderEvents = [];
            contentCreationLeads.forEach(lead => {
                const reminders = lead.contentCreationHistory?.reminders || [];

                reminders.forEach((reminder, index) => {
                    if (reminder.reminderDate && reminder.status !== "Completed") {
                        const shortMessage = reminder.message
                            ? reminder.message
                            : 'Reminder';
                        const reminderId = reminder._id ? reminder._id : null
                        reminderEvents.push({
                            id: `${lead._id}-reminder-${index}`,
                            reminderId: reminderId,
                            title: `${shortMessage}`,
                            start: reminder.reminderDate,
                            allDay: true,
                            extendedProps: {
                                type: 'reminder',
                            },
                            backgroundColor: '#64B5F6',
                            borderColor: '#64B5F6',
                            textColor: '#000'
                        });
                    }
                });
            });

            console.log("Reminder Events:", reminderEvents);
            setEvents(prevEvents => [...prevEvents, ...deadlineEvents, ...reminderEvents]);

        } catch (err) {
            console.error("Error while fetching Content Creation Team:", err);
            toast.error("Failed to load Content Creation Team.");
        }
    };

    const getDailyUpdates = async (id) => {
        debugger
        try {
            const response = await getData(`dailyworkupdates/${id}`, {}, sessionToken);
            console.log("Daily update for the lead:", response)
            const results = response?.data;
            console.log("Results:", results)
            setDailyData(results);

        } catch (err) {
            console.error("Error while fetching Conent Creation Team:", err);
            toast.error("Failed to load Content Creation Team.");
        }

    }

    const getAllUpdatesAdmin = async () => {

        const params = {
            page: 1,
            limit: 1000
        }

        try {
            const response = await getData("dailyworkupdates/updates", params, sessionToken);
            console.log("Response Dailyyy Updates:", response)

            const filteredData = response?.data[0]?.paginatedResults?.filter(lead => lead.serviceName === "Content Creation");

            console.log("Filtered Data:", filteredData);
            setAllUpdates(filteredData); // Store all data here
            // setView(filteredData);

        } catch (err) {
            console.error("Error while fetching Content Creation Team:", err);
            toast.error("Failed to load Content Creation Team.");
        }

    }

    const postDailyWorkUpdate = async () => {
        debugger
        try {
            // First check if updates exist for this lead
            const checkResponse = await getData(`dailyworkupdates/${selectedLeadId}`, {}, sessionToken);
            const existingUpdates = checkResponse?.data?.map(update => update?.contentCreationHistory?.map(history => history?.dailyUpdateId));

            const contentCreationHistory = selectedLead?.contentCreationHistory?.[0] ||
                selectedLead?.contentCreationHistory ||
                {};
            const previousCompleted = contentCreationHistory.completedTasks || 0;
            const newCompleted = parseInt(formData.completedTasks, 10) || 0;
            const totalCompleted = previousCompleted + newCompleted;

            const deadline = selectedLead?.contentCreationHistory?.[0]?.deadline ||
                selectedLead?.contentCreationHistory?.deadline ||
                '';
            const totalTasks = selectedLead?.contentCreationHistory?.[0]?.totalTasks ||
                selectedLead?.contentCreationHistory?.totalTasks ||
                '';
            const amount = selectedLead?.contentCreationHistory?.[0]?.amount ||
                selectedLead?.contentCreationHistory?.amount ||
                '';
            const assignedTo = selectedLead?.contentCreationHistory?.[0]?.assignedTo ||
                selectedLead?.contentCreationHistory?.assignedTo ||
                '';
            const status = selectedLead?.contentCreationHistory?.[0]?.totalTasks === totalCompleted ? "Completed" : "In Progress";

            const payLoad = {
                deadline,
                amount,
                assignedTo,
                status,
                fileUpload: fileUpload,
                comments: formData.comments,
                totalTasks,
                completedTasks: totalCompleted,
                serviceName: "Content Creation",
                leadId: selectedLeadId,
                userId: UserId
            };

            let response;

            if (existingUpdates.length === 0) {
                // POST new update if none exists
                response = await postData('dailyworkupdates', payLoad, sessionToken);
            } else {
                // PUT update existing record
                const updateId = existingUpdates[existingUpdates.length - 1]; // Get first update's ID
                response = await putData(`dailyworkupdates/dailyworkupdates/${updateId}`, payLoad, sessionToken);
            }

            if (response?.status === 200) {
                toast.success("Daily Work Updated Successfully!");
                handleClose();
                getDailyUpdates();
                fetchAssignedLeads()
            } else {
                throw new Error(response?.message || "Failed to update Daily Work.");
            }

        } catch (error) {
            console.error("Error:", error);
            toast.error(error.message);
        }
    };

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        if (currentPage === 1) {
            setLimit(event.target.value)
            fetchAssignedLeads(1, event.target.value)
        }
        else {
            setCurrentPage(1);
            setLimit(event.target.value);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage((prev) => prev - 1);
            fetchAssignedLeads(currentPage - 1, limit);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage((prev) => prev + 1);
            fetchAssignedLeads(currentPage + 1, limit);
        }
    };

    const calculateIndex = (index) => {
        return (currentPage - 1) * limit + index + 1;
    };

    useEffect(() => {
        getAllUsers();
        getAllUpdatesAdmin();
        fetchAssignedLeads(currentPage, limit);
        // getDailyUpdates();
    }, [role, roleType, serviceTeamType, currentPage, limit]);

    const getLeadById = async (id) => {
        debugger
        try {
            const response = await getData(`leads/lead/${id}`, {}, sessionToken)
            if (response.status === 200) {
                console.log(response, "GetLeadById");
                const cameraHistory = response.data.cameraHistory[0];
                setCameraId(cameraHistory._id)
                setConvertData({
                    serviceName: ["Camera Man"],
                    projectName: cameraHistory.projectName || "",
                    shootType: cameraHistory.shootType || "",
                    location: cameraHistory.location || "",
                    assignedTo: cameraHistory.assignedTo ? [cameraHistory.assignedTo] : [],
                    deadline: cameraHistory.deadline
                        ? cameraHistory.deadline.split('T')[0]
                        : "",
                    comments: cameraHistory.comments || "",
                    totalShots: cameraHistory.totalShots || "",
                    paymentStatus: cameraHistory.paymentStatus || ""
                })
            }
        } catch (error) {
            console.log("Error while fetching lead details", error)
        }
    }

    return (
        <>
            <Helmet>
                <title>Service | Content Creation Team</title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Content Creation Team
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                backgroundColor: "white",
                                borderRadius: "15px",
                                padding: "4px 12px",
                                boxShadow: 1,
                                marginRight: "20px"
                            }}
                        >
                            <Iconify icon="eva:search-fill" />
                            <InputBase
                                placeholder="Search"
                                sx={{ marginLeft: "8px" }}
                            />
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2 }}>
                            {
                                (role === "Admin" || roleType === "Team Leader") && (
                                    <Tabs
                                        value={activeTab}
                                        onChange={(e, newValue) => setActiveTab(newValue)}
                                        aria-label="content creation views"
                                    >
                                        <Tab label="Calendar View" />
                                        <Tab label="Table View" />
                                    </Tabs>
                                )
                            }
                        </Box>
                    </Box>
                </Stack>
                <Card sx={{ padding: 2, boxShadow: 3, backgroundColor: "#fff" }}>
                    {(role === "Admin" || roleType === "Team Leader") && activeTab === 0 && (
                        <Box sx={{ height: 500, cursor: "pointer" }}>
                            <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin]}
                                initialView="dayGridMonth"
                                headerToolbar={{
                                    start: "",
                                    center: 'prev title next',
                                    end: ""
                                }}
                                events={events}
                                eventContent={renderEventContent}
                                eventClick={handleReminderClick}
                                height="100%"
                            />
                        </Box>
                    )}
                    {
                        ((role === "Admin" || roleType === "Team Leader") && activeTab === 1) || roleType === "Employee" ? (
                            <>
                                <TableContainer component={Paper} sx={{ boxShadow: "none", backgroundColor: "transparent", maxHeight: 350 }}>
                                    {
                                        role === "Admin" || roleType === "Team Leader" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    {/* <TableCell>Assigned User</TableCell> */}
                                                    <TableCell>Lead Name</TableCell>
                                                    <TableCell>Email</TableCell>
                                                    <TableCell>Phone</TableCell>
                                                    <TableCell>Project</TableCell>
                                                    <TableCell>Completed Tasks</TableCell>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Status</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={9} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((task, id) => {
                                                                return (
                                                                    <TableRow key={task?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        {/* <TableCell>{task?.assignedTo?.name || task?.assignedToHistory[0]?.assignedUser?.name}</TableCell> */}
                                                                        <TableCell>{task?.name}</TableCell>
                                                                        <TableCell>{task?.email}</TableCell>
                                                                        <TableCell>{task?.phone}</TableCell>
                                                                        <TableCell>{task?.contentCreationHistory?.projectName}</TableCell>
                                                                        <TableCell>{task?.contentCreationHistory?.completedTasks} / {task?.contentCreationHistory?.totalTasks}</TableCell>
                                                                        <TableCell>
                                                                            {task?.contentCreationHistory?.fileUpload?.path ?
                                                                                <img
                                                                                    src={task?.contentCreationHistory?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(task?.contentCreationHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#"}
                                                                                    alt='Image.png'
                                                                                    style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        const fullImage = task?.contentCreationHistory?.fileUpload?.path
                                                                                            ? `${file_URL + encodeURI(task?.contentCreationHistory?.fileUpload?.path.replace("public/", ""))}`
                                                                                            : "#";
                                                                                        setSelectedImage(fullImage);
                                                                                        setOpenImage(true);
                                                                                    }}
                                                                                />
                                                                                : "-"}
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={task?.contentCreationHistory?.completionPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {`${Math.round(task?.contentCreationHistory?.completionPercentage)}%`}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={
                                                                                    (event) => handleOpenMenu(event, task, task._id, task.contentCreationHistory?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : roleType === "Employee" ? (
                                            <Table>
                                                <TableHead>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Name</TableCell>
                                                    <TableCell>Contact</TableCell>
                                                    <TableCell>Assigned Work</TableCell>
                                                    <TableCell>Deadline</TableCell>
                                                    <TableCell>Completed Tasks</TableCell>
                                                    <TableCell>File</TableCell>
                                                    <TableCell>Progress</TableCell>
                                                    <TableCell></TableCell>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        assignedLeads?.length === 0 ? (
                                                            <TableRow>
                                                                <TableCell colSpan={9} align="center">
                                                                    No data found
                                                                </TableCell>
                                                            </TableRow>
                                                        ) : (
                                                            assignedLeads?.map((work, id) => {
                                                                return (
                                                                    <TableRow key={work?.id}>
                                                                        <TableCell>{calculateIndex(id)}</TableCell>
                                                                        <TableCell>{work?.name}</TableCell>
                                                                        <TableCell>{work?.phone}</TableCell>
                                                                        <TableCell>{work?.currentWork?.noOfPosters}</TableCell>
                                                                        <TableCell>{work?.currentWork !== null ? new Date(work?.currentWork?.deadline).toLocaleDateString() : "-"}</TableCell>
                                                                        <TableCell>{work?.contentCreationHistory[0]?.completedTasks} / {work?.contentCreationHistory[0]?.totalTasks}</TableCell>
                                                                        <TableCell>
                                                                            <img
                                                                                src={work?.contentCreationHistory[0]?.fileUpload?.path
                                                                                    ? `${file_URL + encodeURI(work?.contentCreationHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                    : "#"}
                                                                                alt='Image.png'
                                                                                style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                onClick={() => {
                                                                                    const fullImage = work?.contentCreationHistory[0]?.fileUpload?.path
                                                                                        ? `${file_URL + encodeURI(work?.contentCreationHistory[0]?.fileUpload?.path.replace("public/", ""))}`
                                                                                        : "#";
                                                                                    setSelectedImage(fullImage);
                                                                                    setOpenImage(true);
                                                                                }}
                                                                            />
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <Box position="relative" display="inline-flex">
                                                                                <CircularProgress
                                                                                    variant="determinate"
                                                                                    value={work?.contentCreationHistory[0]?.completionPercentage}
                                                                                />
                                                                                <Box
                                                                                    top={0}
                                                                                    left={0}
                                                                                    bottom={0}
                                                                                    right={0}
                                                                                    position="absolute"
                                                                                    display="flex"
                                                                                    alignItems="center"
                                                                                    justifyContent="center"
                                                                                >
                                                                                    <Typography variant="caption" component="div" color="text.secondary">
                                                                                        {typeof work?.contentCreationHistory[0]?.completionPercentage === 'number'
                                                                                            ? `${Math.round(work.contentCreationHistory[0].completionPercentage)}%`
                                                                                            : '0%'}
                                                                                    </Typography>
                                                                                </Box>
                                                                            </Box>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            <Iconify
                                                                                icon="material-symbols-light:more-vert"
                                                                                sx={{ margin: "auto" }}
                                                                                onClick={(event) => handleOpenMenu(event, work, work._id, work?.contentCreationHistory[0]?.dailyUpdateId)}
                                                                            />
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )
                                                            })
                                                        )
                                                    }
                                                </TableBody>
                                            </Table>
                                        ) : null
                                    }
                                </TableContainer>
                                <PaginationComponent
                                    name={"Leads"}
                                    totalcount={totalCount}
                                    limit={limit}
                                    handleLimitChange={handleLimitChange}
                                    handlePrevPage={handlePrevPage}
                                    handleNextPage={handleNextPage}
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                />
                            </>
                        ) : null}
                </Card>

                {/* Events Dialog */}
                <Dialog open={open} onClose={() => setOpen(false)}>
                    <DialogTitle>Daily Work Update</DialogTitle>
                    <DialogContent>
                        <TextField
                            name="completedTasks"
                            label="Completed Tasks"
                            type="number"
                            fullWidth
                            margin="dense"
                            value={formData.completedTasks}
                            onChange={handleFormChange}
                        />
                        {/* <TextField
                            name="status"
                            label="Status"
                            fullWidth
                            select
                            margin="dense"
                            value={formData.status}
                            onChange={handleFormChange}
                        >
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="In Progress">In Progress</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                        </TextField> */}
                        <TextField
                            name="comments"
                            label="Comments"
                            fullWidth
                            margin="dense"
                            value={formData.comments}
                            onChange={handleFormChange}
                        />
                        <TextField
                            margin='dense'
                            type='file'
                            hidden
                            label="Upload File"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => handleFileChange(e)}
                        >
                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpen(false)} color="secondary">Cancel</Button>
                        <Button color="primary" onClick={postDailyWorkUpdate}>Update</Button>
                    </DialogActions>
                </Dialog>

                <Popover
                    open={Boolean(openMenu)}
                    anchorEl={openMenu}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            p: 1,
                            width: 140,
                            '& .MuiMenuItem-root': {
                                px: 1,
                                typography: 'body2',
                                borderRadius: 0.75,
                            },
                        },
                    }}
                >
                    {role === "Admin" ? (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                Assign To
                            </MenuItem>
                        </>
                    ) : roleType === "Team Leader" ? (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={() => handleFormOpen(selectedLeadId)}>
                                <Iconify icon="material-symbols:sync-alt" sx={{ mr: 2 }} />
                                Convert
                            </MenuItem>
                            {/* <MenuItem onClick={handleOpen}>
                                <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                Work Update
                            </MenuItem> */}
                        </>
                    ) : (
                        <>
                            <MenuItem onClick={handleOpenDialog}>
                                <Iconify icon={'material-symbols:visibility'} sx={{ mr: 2 }} />
                                View
                            </MenuItem>
                            <MenuItem onClick={handleOpen}>
                                <Iconify icon={'eva:edit-fill'} sx={{ mr: 1 }} />
                                Work Update
                            </MenuItem>
                            {/* <MenuItem sx={{ color: 'error.main' }}>
                                <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                                Delete
                            </MenuItem> */}
                        </>
                    )}
                </Popover>

                <Dialog
                    open={details}
                    onClose={handleCloseDialog}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography variant="h5" component="div" sx={{ fontWeight: 'bold' }}>
                            Daily Work Updates
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers={scroll === 'paper'}>
                        <DialogContentText
                            id="scroll-dialog-description"
                            ref={descriptionElementRef}
                            component="div" // Ensure DialogContentText renders as a div to contain Box/Grid
                        >
                            {!view || Object.keys(view).length === 0 ? (
                                <Box sx={{ p: 3, textAlign: 'center' }}>
                                    <Typography variant="h6" color="text.secondary">No data found</Typography>
                                </Box>
                            ) : (
                                <Box sx={{ p: 1 }}>
                                    <Paper elevation={3} sx={{
                                        p: 2,
                                        backgroundColor: '#ffffff',
                                        borderRadius: 2,
                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                        borderLeft: '5px solid #1976d2' // A subtle accent line
                                    }}>
                                        {
                                            role === "Admin" || roleType === "Team Leader" ? (
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} id="paddingTop">
                                                        <Typography variant="h6" sx={{ color: '#333' }}>
                                                            Project Details
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Name: {view?.name}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Status: <Typography component="span" sx={{
                                                                fontWeight: 'bold',
                                                                color: view?.contentCreationHistory?.status === 'Completed' ? 'success.main' :
                                                                    view?.contentCreationHistory?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                            }}>
                                                                {view?.contentCreationHistory?.status}
                                                            </Typography>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Deadline: {new Date(view?.contentCreationHistory?.deadline).toLocaleDateString()}
                                                        </Typography>
                                                    </Grid>
                                                    {view?.socialMediaHistory?.deadline && (
                                                        <Grid item xs={12} sm={6} id="paddingTop">
                                                            <Typography variant='body1'>
                                                                Project Deadline:   {new Date(view?.socialMediaHistory?.deadline).toLocaleDateString()}
                                                            </Typography>
                                                        </Grid>
                                                    )}

                                                    <Grid item xs={12} id="paddingTop">
                                                        <Typography variant="h6" sx={{ color: '#333' }}>
                                                            Task Progress
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Completed Tasks: {view?.contentCreationHistory?.completedTasks}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Total Tasks: {view?.contentCreationHistory?.totalTasks}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} id="paddingTop">
                                                        <Typography variant="body1">
                                                            Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                                {view?.contentCreationHistory?.completionPercentage}%
                                                            </Typography>
                                                        </Typography>
                                                    </Grid>

                                                    {view?.[0]?.contentCreationHistory?.comments && (
                                                        <Grid item xs={12} id="paddingTop">
                                                            <Typography variant="h6" sx={{ mt: 2, mb: 1, color: '#333' }}>
                                                                Comments
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                                                                "{view?.[0]?.contentCreationHistory?.comments}"
                                                            </Typography>
                                                        </Grid>
                                                    )}

                                                    <Grid item xs={12} id="paddingTop">
                                                        <Typography variant="h6" sx={{ color: '#333' }}>
                                                            Timestamps
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body2" color="text.secondary">
                                                            Created: {new Date(view?.createdAt).toLocaleString()}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6} id="paddingTop">
                                                        <Typography variant="body2" color="text.secondary">
                                                            Updated: {new Date(view?.updatedAt).toLocaleString()}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            ) : (
                                                null
                                            )
                                        }
                                        {
                                            roleType === "Employee" && (
                                                <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                                                    <Table sx={{ minWidth: 350 }} aria-label="customized table">
                                                        <TableBody>
                                                            {view?.contentCreationHistory?.map((history, hIndex) => (
                                                                // row?.contentCreationHistory?.map((history, hIndex) => (
                                                                <TableRow
                                                                    key={`${view?.name || "row"}-${hIndex}`}
                                                                    hover
                                                                    onClick={() => {
                                                                        const fileUrl = `${file_URL + encodeURI(
                                                                            history.fileUpload.path.replace("public/", "")
                                                                        )}`;
                                                                        window.open(fileUrl, "_blank");
                                                                    }}
                                                                >
                                                                    <TableCell align="right">{hIndex + 1}</TableCell>
                                                                    <TableCell align="right">
                                                                        {history?.fileUpload?.path ? (
                                                                            (() => {
                                                                                const filePath = history.fileUpload.path.toLowerCase();
                                                                                const fileUrl = `${file_URL + encodeURI(
                                                                                    history.fileUpload.path.replace("public/", "")
                                                                                )}`;
                                                                                if (filePath.endsWith(".docx")) {
                                                                                    return (
                                                                                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                            <img src={wordIcon} alt='Image.jpg' height="50" width="50" />
                                                                                        </a>
                                                                                    );
                                                                                }
                                                                                else if (filePath.endsWith(".pdf")) {
                                                                                    return (
                                                                                        <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                                                                                            <img src={pdfIcon} alt='Image.jpg' height="50" width="50" />
                                                                                        </a>
                                                                                    );
                                                                                }
                                                                                else if (filePath.endsWith(".jpg") || filePath.endsWith(".jpeg") || filePath.endsWith(".png") || filePath.endsWith(".webp") || filePath.endsWith(".avif")) {
                                                                                    return (
                                                                                        <img
                                                                                            src={fileUrl}
                                                                                            alt="Uploaded File"
                                                                                            style={{ maxWidth: "50px", cursor: "pointer" }}
                                                                                        />
                                                                                    );
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <span style={{ fontSize: "20px" }}>-</span>
                                                                                    );
                                                                                }
                                                                            })()
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell align="right">{history?.comments || "-"}</TableCell>
                                                                    <TableCell align="right">
                                                                        {history?.updatedAt
                                                                            ? new Date(history.updatedAt).toLocaleString()
                                                                            : "-"}
                                                                    </TableCell>
                                                                </TableRow>
                                                                // ))
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            )
                                        }
                                    </Paper>
                                </Box>
                            )}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ p: 2 }}>
                        <Button onClick={handleCloseDialog} variant="contained" color="primary">Close</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openImage} onClose={() => setOpenImage(false)} maxWidth="md">
                    <Iconify
                        icon="material-symbols:close"
                        onClick={() => setOpenImage(false)}
                        style={{
                            position: 'absolute',
                            top: 10,
                            right: 10,
                            fontSize: 24,
                            cursor: 'pointer',
                            zIndex: 1
                        }}
                    />
                    <DialogContent>
                        <img src={selectedImage} alt="Full View" style={{ width: "100%", height: "auto" }} />
                    </DialogContent>
                </Dialog>

                <Dialog open={convertForm}>
                    <DialogTitle>Convert Leads</DialogTitle>
                    <DialogContent>
                        {
                            role === "Admin" ? (
                                <>
                                    <TextField
                                        name="projectName"
                                        label="Project Name"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.projectName}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        name="shootType"
                                        label="Shoot Type"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.shootType}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        name="location"
                                        label="Location"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.location}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        name="assignedTo"
                                        label="Assigned Photographer"
                                        fullWidth
                                        select
                                        margin="dense"
                                        value={convertData.assignedTo}
                                        onChange={handleInputChange}
                                    >
                                        {employeeOptions.map((photographer) => (
                                            <MenuItem key={photographer.id} value={photographer.id}>
                                                {photographer.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <TextField
                                        name="deadline"
                                        label="Deadline"
                                        type="date"
                                        fullWidth
                                        margin="dense"
                                        InputLabelProps={{ shrink: true }}
                                        value={convertData.deadline}
                                        onChange={handleInputChange}
                                    />
                                    <TextField
                                        name="comments"
                                        label="Additional Comments"
                                        fullWidth
                                        multiline
                                        rows={3}
                                        margin="dense"
                                        value={convertData.comments}
                                        onChange={handleInputChange}
                                    />
                                    {/* <TextField
                                        name="totalShots"
                                        label="Total Shots"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.totalShots}
                                        onChange={handleInputChange}
                                    /> */}
                                    <div style={{ display: "flex", justifyContent: "flex-start" }}>
                                        <Typography variant="body1" style={{ margin: "5px 0px 0px 10px" }} gutterBottom>
                                            Total Tasks: {convertData.totalShots}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            style={{ margin: "5px 0px 0px 10px" }}
                                            gutterBottom
                                        >
                                            Pending Tasks: {view?.contentCreationHistory?.totalTasks - view?.contentCreationHistory?.completedTasks}
                                        </Typography>
                                    </div>
                                    <TextField
                                        name="assignedShots"
                                        label="Videos To Assign"
                                        fullWidth
                                        margin="dense"
                                        value={convertData.assignedShots}
                                        onChange={handleInputChange}
                                    />
                                    <TextField margin="dense" select label="Payment Status" name="paymentStatus" value={convertData.paymentStatus || ''} onChange={handleInputChange} fullWidth>
                                        {["Pending", "Completed"].map(p => (
                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                        ))}
                                    </TextField>
                                </>
                            ) : roleType === "Team Leader" ? (
                                <>
                                    <FormControl fullWidth margin="dense">
                                        <InputLabel id="assign-to-label">Assign To</InputLabel>
                                        <Select
                                            labelId="assign-to-label"
                                            multiple
                                            value={convertData.assignedTo}
                                            onChange={handleMultiSelectChange}
                                            InputLabelProps={{ shrink: true }}
                                            label="Assign To"
                                            input={<OutlinedInput label="Assign To" />}
                                            renderValue={(selected) => (
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                    {selected.map((value) => {
                                                        const employee = employeeOptions.find(emp => emp.id === value);
                                                        return employee ? (
                                                            <Chip key={value} label={employee.name} />
                                                        ) : null;
                                                    })}
                                                </Box>
                                            )}
                                            fullWidth
                                        >
                                            {employeeOptions.map((emp) => (
                                                <MenuItem key={emp.id} value={emp.id}>
                                                    {emp.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                    <Box sx={{ mt: 2 }}>
                                        {Array.isArray(convertData.assignedTo) && convertData.assignedTo.length > 0 &&
                                            convertData.assignedTo.map((empId) => {
                                                const employee = employeeOptions.find(emp => emp.id === empId);
                                                return (
                                                    <>
                                                        <Box key={empId} sx={{ display: 'flex', alignItems: 'center', mb: 1, gap: 2 }}>
                                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px" }}>
                                                                <div className='col' style={{ marginTop: "5px" }}>
                                                                    <Typography>{employee?.name}</Typography>
                                                                </div>
                                                            </div>
                                                        </Box>
                                                        <Box key={empId} sx={{ alignItems: 'center', mb: 1, gap: 2 }}>
                                                            <div style={{ display: "flex", justifyContent: "center", gap: "20px", marginBottom: "10px" }}>
                                                                <TextField
                                                                    label="No of Contents"
                                                                    value={convertData.employeeWork?.[empId]?.noOfPosters || ""}
                                                                    onChange={(e) => {
                                                                        const work = e.target.value;
                                                                        setConvertData(prev => ({
                                                                            ...prev,
                                                                            employeeWork: {
                                                                                ...prev.employeeWork,
                                                                                [empId]: {
                                                                                    ...prev.employeeWork?.[empId],
                                                                                    noOfPosters: work
                                                                                }
                                                                            }
                                                                        }));
                                                                    }}
                                                                    size="small"
                                                                    fullWidth
                                                                />
                                                                <TextField
                                                                    label="Deadline"
                                                                    value={convertData.employeeWork?.[empId]?.deadline || ""}
                                                                    onChange={(e) => {
                                                                        const work = e.target.value;
                                                                        setConvertData(prev => ({
                                                                            ...prev,
                                                                            employeeWork: {
                                                                                ...prev.employeeWork,
                                                                                [empId]: {
                                                                                    ...prev.employeeWork?.[empId],
                                                                                    deadline: work
                                                                                }
                                                                            }
                                                                        }));
                                                                    }}
                                                                    type='date'
                                                                    size="small"
                                                                    fullWidth
                                                                    InputLabelProps={{ shrink: true }}
                                                                />
                                                            </div>
                                                        </Box>
                                                    </>
                                                );
                                            })}
                                    </Box>
                                </>
                            ) : null
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleFormClose} color="secondary">Cancel</Button>
                        <Button onClick={convertLeads} color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={openReminderDialog} onClose={handleCloseReminderDialog}>
                    <DialogTitle>{selectedReminder?.reminderMessage}</DialogTitle>
                    <DialogContent>
                        {selectedReminder && (
                            <Box sx={{ p: 1 }}>
                                <Paper elevation={3} sx={{
                                    p: 2,
                                    backgroundColor: '#ffffff',
                                    borderRadius: 2,
                                    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                    borderLeft: '5px solid #1976d2'
                                }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Name: {selectedReminder?.leadName}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Project Name: {selectedReminder?.projectName}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Status: <Typography component="span" sx={{
                                                    fontWeight: 'bold',
                                                    color: selectedReminder?.status === 'Completed' ? 'success.main' :
                                                        selectedReminder?.status === 'In Progress' ? 'warning.main' : 'error.main'
                                                }}>
                                                    {selectedReminder?.status}
                                                </Typography>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Deadline: {new Date(selectedReminder?.deadline).toLocaleDateString()}
                                            </Typography>
                                        </Grid>
                                        {/* <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Reminder Message: {selectedReminder?.reminderMessage}
                                            </Typography>
                                        </Grid> */}
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Completed Tasks: {selectedReminder?.completedTasks}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Total Tasks: {selectedReminder?.totalTasks}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body1">
                                                Progress: <Typography component="span" sx={{ fontWeight: 'bold', color: '#007bff' }}>
                                                    {selectedReminder?.completionPercentage}%
                                                </Typography>
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Created: {new Date(selectedReminder?.createdAt).toLocaleString()}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} id="paddingTop" sx={{ marginBottom: 1 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                Updated: {new Date(selectedReminder?.updatedAt).toLocaleString()}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseReminderDialog} color="secondary">Close</Button>
                        <Button onClick={handleMarkReminderCompleted} color="primary">Mark as Completed</Button>
                    </DialogActions>
                </Dialog>

            </Container >
        </>
    );
}

function renderEventContent(eventInfo) {
    const isDeadline = eventInfo.event.extendedProps.type === 'deadline';
    const extendedProps = eventInfo.event.extendedProps;
    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: isDeadline ? '#FFEBEE' : '#F5F5F5',
            borderRadius: '8px',
            padding: '6px',
            marginTop: '5px',
            boxShadow: 2,
            fontSize: '12px',
            color: 'black',
            maxWidth: "125px",
            borderLeft: `4px solid ${extendedProps.color || eventInfo.event.backgroundColor || '#90CAF9'}`,
            wordWrap: extendedProps ? 'break-word' : 'normal',
            whiteSpace: extendedProps ? 'normal' : 'nowrap',
            overflowWrap: extendedProps ? 'anywhere' : 'normal',

        }}>
            <Box sx={{
                paddingLeft: '6px'
            }}>
                {isDeadline && (
                    <>
                        <strong>⏰</strong>
                        <div>Lead: {eventInfo.event.extendedProps.leadName}</div>
                        <div>Progress: {eventInfo.event.extendedProps.progress}</div>
                    </>
                )}
                {
                    !isDeadline && extendedProps && (
                        <>
                            <strong>📝 {eventInfo.event.title}</strong>
                        </>
                    )
                }
            </Box>
        </Box>
    );
}


export default ContentCreation;
